import { render, staticRenderFns } from "./ServiceHome.vue?vue&type=template&id=34a59d22&"
import script from "./ServiceHome.vue?vue&type=script&lang=js&"
export * from "./ServiceHome.vue?vue&type=script&lang=js&"
import style0 from "./ServiceHome.vue?vue&type=style&index=0&id=34a59d22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports